webpackJsonp([14],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return AUTHENTICATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPDATE_USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SHOW_LOGIN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return HIDE_LOGIN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SHOW_SIGNUP_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return HIDE_SIGNUP_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SHOW_RESET_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return HIDE_RESET_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_USER_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return AUTHENTICATION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CLEAR_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLEAR_BASKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_BASKET_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_BASKET_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_BASKET_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_BASKET_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_ORDER_RECIPIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_BACKEND_ORDER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CLEAR_BACKEND_ORDER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CLEAR_ORDER_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_ORDER_PAYMENT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_TOWNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_CITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_REGIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_MENU_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_RESTAURANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PAYMENT_MODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SET_BODY_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_PAGE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SHOW_APP_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return HIDE_APP_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return HIDE_MOBILE_NAV; });
/* unused harmony export SHOW_APP_FULL_LOADER */
/* unused harmony export HIDE_APP_FULL_LOADER */

var LOGOUT = 'LOGOUT';
var AUTHENTICATE = 'AUTHENTICATE';
var UPDATE_USER_INFO = 'UPDATE_USER_INFO';
var SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';
var HIDE_LOGIN_MODAL = 'HIDE_LOGIN_MODAL';
var SHOW_SIGNUP_MODAL = 'SHOW_SIGNUP_MODAL';
var HIDE_SIGNUP_MODAL = 'HIDE_SIGNUP_MODAL';
var SHOW_RESET_MODAL = 'SHOW_RESET_MODAL';
var HIDE_RESET_MODAL = 'HIDE_RESET_MODAL';
var SET_USER_LOCATION = 'SET_USER_LOCATION';
var AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED';

var SET_ORDER = 'SET_ORDER';
var SET_ORDERS = 'SET_ORDERS';
var CLEAR_ORDER = 'CLEAR_ORDER';
var CLEAR_BASKET = 'CLEAR_BASKET';
var SET_BASKET_ITEM = 'SET_BASKET_ITEM';
var SET_BASKET_COUNT = 'SET_BASKET_COUNT';
var UPDATE_BASKET_ITEM = 'UPDATE_BASKET_ITEM';
var DELETE_BASKET_ITEM = 'DELETE_BASKET_ITEM';
var SET_ORDER_RECIPIENT = 'SET_ORDER_RECIPIENT';
var SET_BACKEND_ORDER_ID = 'SET_BACKEND_ORDER_ID';
var CLEAR_BACKEND_ORDER_ID = 'CLEAR_BACKEND_ORDER_ID';
var CLEAR_ORDER_INFORMATION = 'CLEAR_ORDER_INFORMATION';
var SET_ORDER_PAYMENT_DETAILS = 'SET_ORDER_PAYMENT_DETAILS';

var SET_TOWNS = 'SET_TOWNS';
var SET_CITIES = 'SET_CITIES';
var SET_REGIONS = 'SET_REGIONS';

var SET_MENU_ITEMS = 'SET_MENU_ITEMS';

var SET_RESTAURANTS = 'SET_RESTAURANTS';

var SET_PAYMENT_MODES = 'SET_PAYMENT_MODES';

var SET_SETTINGS = 'SET_SETTINGS';

var SET_BODY_CLASS = 'SET_BODY_CLASS';
var SET_PAGE_TITLE = 'SET_PAGE_TITLE';
var SHOW_APP_LOADER = 'SHOW_APP_LOADER';
var HIDE_APP_LOADER = 'HIDE_APP_LOADER';
var HIDE_MOBILE_NAV = 'HIDE_MOBILE_NAV';
var SHOW_APP_FULL_LOADER = 'SHOW_APP_FULL_LOADER';
var HIDE_APP_FULL_LOADER = 'HIDE_APP_FULL_LOADER';

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return axios; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app__ = __webpack_require__(41);





var axios = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: __WEBPACK_IMPORTED_MODULE_3__config_app__["a" /* default */].baseURL,

	headers: {
		'X-Requested-With': 'XMLHttpRequest'
	}
});

axios.interceptors.request.use(function (config) {
	var apiToken = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* store */].getters['User/getUser'].api_token;

	if (apiToken && !config.headers.common.Authorization) {
		config.headers.common.Authorization = 'Bearer ' + apiToken;
	}

	return config;
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules__ = __webpack_require__(130);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
	state: {
		bodyClass: 'index-page',
		showLoader: false,
		currentPageTitle: ''
	},

	getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
	actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
	mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
	modules: __WEBPACK_IMPORTED_MODULE_5__modules__["a" /* default */]
});

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(117);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_3__routes__["a" /* default */],
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('showLoader');

  var isUserLocationSet = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].getters['User/isLocationSet'];

  if (!isUserLocationSet && to.name.toLowerCase() !== 'location') {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setPageTitle', 'Location');
    next({ name: 'location' });
  }

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setPageTitle', to.name.replace('_', ' ').toTitleCase());
  next();
});

router.afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('hideLoader');
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('hideMobileNav');
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Globals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Orders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__order__ = __webpack_require__(116);



var Globals = __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */];
var Orders = __WEBPACK_IMPORTED_MODULE_1__order__["a" /* default */];

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	baseURL: 'https://api.ezifood.com/api/v1',
	serviceRates: {
		paid: 0.03,
		free: 0
	}
});


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = ({
		all: function all(params) {
				return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('orders', {
						params: params
				}).then(function (response) {
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
				}).catch(function (error) {
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
				});
		},
		store: function store(order) {
				return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].post('orders', order).then(function (response) {
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
				}).catch(function (error) {
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
				});
		},
		show: function show(id) {
				return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('orders/' + id).then(function (response) {
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
				}).catch(function (error) {
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
				});
		},
		check: function check(id) {
				return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('orders/payment/check/' + id).then(function (response) {
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
				}).catch(function (error) {
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
				});
		}
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(214),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ebd8e98",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_Login__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_Signup__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_Signup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_auth_Signup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_ResetModal__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_ResetModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_auth_ResetModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_partials_FloatingBasket__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_partials_FloatingBasket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_partials_FloatingBasket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(8);










/* harmony default export */ __webpack_exports__["default"] = ({
	components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_layouts__["a" /* default */], {
		AppLogin: __WEBPACK_IMPORTED_MODULE_2__components_auth_Login___default.a,
		AppSignup: __WEBPACK_IMPORTED_MODULE_3__components_auth_Signup___default.a,
		AppReset: __WEBPACK_IMPORTED_MODULE_4__components_auth_ResetModal___default.a,
		MobileBasket: __WEBPACK_IMPORTED_MODULE_5__components_partials_FloatingBasket___default.a
	}),

	data: function data() {
		return {
			isMobile: false
		};
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])({
		isUserLoggedIn: 'User/isLoggedIn',
		isUserLocationSet: 'User/isLocationSet',
		getUser: 'User/getUser',
		showLoader: 'showLoaderStatus',
		showLoginModal: 'User/shouldShowLogin',
		showSignupModal: 'User/shouldShowSignup',
		showResetModal: 'User/shouldShowReset',
		basketCount: 'Basket/getCount'
	}), {
		showMobileBasket: function showMobileBasket() {
			var excludedRoutes = ['location', 'checkout', 'basket', 'awaiting_payment'];

			return this.isMobile && this.basketCount && excludedRoutes.indexOf(this.$route.name) === -1;
		}
	}),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])({
		logout: 'User/logout'
	}), {
		logoutUser: function logoutUser() {
			this.logout();
			this.notify({
				message: 'You have successfully logged out. Come back soon.',
				type: 'success'
			});

			if (this.$route.name === 'my_account') {
				this.$router.push({ name: 'home' });
			}
		},
		checkForMobile: function checkForMobile() {
			this.isMobile = $(window).width() < 769;
		}
	}),

	mounted: function mounted() {
		this.checkForMobile();

		$(window).on('resize', this.checkForMobile);
	}
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['isOpenModal'],

	data: function data() {
		return {
			rules: {
				email: 'required|email',
				password: 'required|min:6'
			},

			user: {
				email: '',
				password: ''
			}
		};
	},


	computed: {
		allowLogin: function allowLogin() {
			if (!this.user.email || !this.user.password || this.errors.any()) {
				return false;
			}

			return true;
		}
	},

	watch: {
		isOpenModal: function isOpenModal(value) {
			if (value) {
				this.openModal();
			} else {
				this.closeModal();
			}
		}
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
		authenticate: 'User/authenticate',
		showLoginModal: 'User/setShowLogin',
		showSignupModal: 'User/setShowSignup',
		showResetModal: 'User/setShowReset'
	}), {
		openModal: function openModal() {
			var _this = this;

			$('#login-modal').appendTo('body').modal({
				backdrop: 'static'
			});

			this.$nextTick(function () {
				_this.errors.clear();
			});
		},
		closeModal: function closeModal() {
			$('#login-modal').modal('hide');
			this.resetForm();
			this.showLoginModal(false);
		},
		resetForm: function resetForm() {
			this.user.email = '';
			this.user.password = '';
			this.errors.clear();
		},
		loginUser: function loginUser() {
			var _this2 = this;

			this.showLoader();
			this.$validator.validateAll().then(function () {
				return _this2.authenticate(_this2.user);
			}).then(function (response) {
				_this2.closeModal();

				_this2.notify({
					message: 'You have successfully logged in.',
					type: 'success'
				});
			}).catch(function (errors) {
				_this2.buildErrorMessages(errors).then(function (data) {
					_this2.notify({
						message: data,
						type: 'danger'
					});
				});
			}).then(function () {
				return _this2.hideLoader();
			});
		},
		initSignup: function initSignup() {
			this.closeModal();
			this.showSignupModal(true);
		},
		initReset: function initReset() {
			this.closeModal();
			this.showResetModal(true);
		}
	})
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['isOpenModal'],

	data: function data() {
		return {
			rules: {
				email: 'required|email'
			},

			email: ''
		};
	},


	watch: {
		isOpenModal: function isOpenModal(value) {
			if (value) {
				this.openModal();
			} else {
				this.closeModal();
			}
		}
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
		showResetModal: 'User/setShowReset',
		requestReset: 'User/requestPasswordReset'
	}), {
		openModal: function openModal() {
			$('#reset-modal').appendTo('body').modal({
				backdrop: 'static'
			});
		},
		closeModal: function closeModal() {
			$('#reset-modal').modal('hide');
			this.resetForm();
			this.showResetModal(false);
		},
		resetForm: function resetForm() {
			this.email = "";
			this.errors.clear();
		},
		sendRequest: function sendRequest() {
			var _this = this;

			var notification = void 0;

			this.showLoader();

			this.requestReset({
				email: this.email
			}).then(function (response) {
				notification = {
					message: 'A password reset token has been sent to your email',
					type: 'success'
				};

				_this.notify(notification);
				_this.resetForm();
				_this.closeModal();
				_this.$router.push({
					name: 'reset'
				});
			}).catch(function (error) {
				_this.buildErrorMessages(error).then(function (data) {
					notification = {
						message: data,
						type: 'danger'
					};

					_this.notify(notification);
				});
			}).then(function () {
				return _this.hideLoader();
			});
		}
	})
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);








/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['isOpenModal'],

	data: function data() {
		return {
			rules: {
				name: 'required',
				email: 'required|email',
				phone: 'required|min:10|max:15',
				password: 'required|min:6',
				password_confirmation: 'required'
			},

			user: {
				name: '',
				email: '',
				phone: '',
				password: '',
				password_confirmation: ''
			},

			showNextStep: false
		};
	},


	computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		userLocation: 'User/getLocation'
	}), {
		allowNext: function allowNext() {
			if (!this.user.name || !this.user.email || !this.user.phone) {
				return false;
			}

			if (this.errors.has('name') || this.errors.has('email') || this.errors.has('phone')) {
				return false;
			}

			return true;
		},
		allowSignup: function allowSignup() {
			var allow = true;

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.user)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var field = _step.value;

					if (!field) {
						allow = false;
						break;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.errors.any()) {
				allow = false;
			}

			return allow;
		}
	}),

	watch: {
		isOpenModal: function isOpenModal(value) {
			if (value) {
				this.openModal();
			} else {
				this.closeModal();
			}
		}
	},

	methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
		signup: 'User/signup',
		showLoginModal: 'User/setShowLogin',
		showSignupModal: 'User/setShowSignup'
	}), {
		openModal: function openModal() {
			$('#signup-modal').appendTo('body').modal({
				backdrop: 'static'
			});
		},
		closeModal: function closeModal() {
			$('#signup-modal').modal('hide');
			this.resetForm();
			this.showSignupModal(false);
		},
		resetForm: function resetForm() {
			this.user.name = '';
			this.user.phone = '';
			this.user.email = '';
			this.user.password = '';
			this.errors.clear();
		},
		signupUser: function signupUser() {
			var _this = this;

			this.showLoader();
			this.$validator.validateAll().then(function () {
				var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.user);
				data.town_id = _this.userLocation.town_id;

				return _this.signup(data);
			}).then(function (response) {
				_this.closeModal();

				_this.notify({
					message: 'You have successfully created an account.',
					type: 'success'
				});
			}).catch(function (errors) {
				_this.buildErrorMessages(errors).then(function (data) {
					_this.notify({
						message: data,
						type: 'danger'
					});
				});
			}).then(function () {
				return _this.hideLoader();
			});
		},
		goToNextStep: function goToNextStep() {
			this.showNextStep = true;
		},
		goToPreviousStep: function goToPreviousStep() {
			this.showNextStep = false;
		},
		initLogin: function initLogin() {
			this.closeModal();
			this.showLoginModal(true);
		}
	})
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			currentYear: new Date().getFullYear(),

			rules: {
				email: 'required|email',
				'phone': 'required|min:10',
				'message': 'required'
			},

			contactUs: {
				email: '',
				phone: '',
				message: ''
			}
		};
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
		sendMessage: 'User/sendMessage'
	}), {
		resetForm: function resetForm() {
			var _this = this;

			this.contactUs.email = '';
			this.contactUs.phone = '';
			this.contactUs.message = '';

			this.$nextTick(function () {
				_this.errors.clear();
			});
		},
		sendUserMessage: function sendUserMessage() {
			var _this2 = this;

			this.showLoader();
			this.$validator.validateAll().then(function () {
				return _this2.sendMessage(_this2.contactUs);
			}).then(function (response) {
				_this2.resetForm();

				_this2.notify({
					message: 'Your message was sent successfully.',
					type: 'success'
				});
			}).catch(function (errors) {
				_this2.buildErrorMessages(errors).then(function (data) {
					_this2.notify({
						message: data,
						type: 'danger'
					});
				});
			}).then(function () {
				return _this2.hideLoader();
			});
		}
	})
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    pageTitle: 'pageTitle',
    isUserLoggedIn: 'User/isLoggedIn',
    basketCount: 'Basket/getCount'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    showLoginModal: 'User/setShowLogin',
    showSignupModal: 'User/setShowSignup',
    showResetModal: 'User/setShowReset'
  }), {
    loginUser: function loginUser() {
      this.showLoginModal(true);
    },
    initReset: function initReset() {
      this.showResetModal(true);
    },
    signupUser: function signupUser() {
      this.showSignupModal(true);
    },
    logoutUser: function logoutUser() {
      this.$emit('logout');
    }
  })
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['isOpenModal', 'resourceId', 'rel'],

	watch: {
		isOpenModal: function isOpenModal(value) {
			if (value) {
				this.openModal();
			} else {
				this.closeModal();
			}
		}
	},

	methods: {
		openModal: function openModal() {
			$('div[id=' + this.rel + '-delete-modal]').not(':last-child').remove();

			$('#' + this.rel + '-delete-modal').appendTo('body').modal({
				backdrop: 'static'
			});
		},
		closeModal: function closeModal() {
			$('#' + this.rel + '-delete-modal').modal('hide');
			this.$emit('modalClosed');
		},
		deleteResource: function deleteResource() {
			this.$emit('deletionConfirmed', this.resourceId);
			this.closeModal();
		}
	}
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['show']
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["default"] = ({
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
		basketCount: 'Basket/getCount'
	})),

	methods: {
		goToBasket: function goToBasket() {
			this.$router.push({ name: 'basket' });
		}
	}
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['pageDetails', 'routeName'],

	computed: {
		prevPage: function prevPage() {
			return this.pageDetails.currentPage != 1 ? this.pageDetails.currentPage - 1 : 1;
		},
		nextPage: function nextPage() {
			return this.pageDetails.currentPage != this.pageDetails.lastPage ? this.pageDetails.currentPage + 1 : this.pageDetails.lastPage;
		},
		showPagination: function showPagination() {
			return this.pageDetails.total > this.pageDetails.perPage;
		}
	},

	methods: {
		navigate: function navigate(pageNumber, event) {
			var element = $(event.target).is('span') ? $(event.target).parent('a') : $(event.target);

			if (element.attr('disabled') === 'disabled') {
				return;
			}

			var query = {
				page: pageNumber,
				per_page: this.pageDetails.perPage
			};

			this.$emit('navigate', query);
		}
	}
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Footer__);



/* harmony default export */ __webpack_exports__["a"] = ({
	AppHeader: __WEBPACK_IMPORTED_MODULE_0__Header___default.a,
	AppFooter: __WEBPACK_IMPORTED_MODULE_1__Footer___default.a
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorLabel__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ErrorLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DeleteModal__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DeleteModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DeleteModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pagination__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Pagination__);





/* harmony default export */ __webpack_exports__["a"] = ({
	AppLoader: __WEBPACK_IMPORTED_MODULE_0__Loader___default.a,
	ErrorLabel: __WEBPACK_IMPORTED_MODULE_1__ErrorLabel___default.a,
	DeleteModal: __WEBPACK_IMPORTED_MODULE_2__DeleteModal___default.a,
	AppPagination: __WEBPACK_IMPORTED_MODULE_3__Pagination___default.a
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(27);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
	mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* Globals */]]
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* router */],
	store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* store */],
	template: '<App/>',

	components: {
		App: __WEBPACK_IMPORTED_MODULE_2__App___default.a
	}
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_partials__ = __webpack_require__(113);





/* harmony default export */ __webpack_exports__["a"] = ({
	components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__components_partials__["a" /* default */]),

	filters: {
		formattedDate: function formattedDate(value) {
			var date = moment(value);
			return date.isValid() ? date.format('ddd Do MMM, YYYY') : value;
		},
		formattedDateTime: function formattedDateTime(value) {
			var date = moment(value);
			return date.isValid() ? date.format('ddd Do MMM, YYYY hh:mm:A') : value;
		},
		firstLetter: function firstLetter($value) {
			return $value.toString().toUpperCase().charAt(0);
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
		getRegions: 'Regions/getAll',
		getCities: 'Cities/getAll',
		getTowns: 'Towns/getAll'
	})),

	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
		loadRegions: 'Regions/all',
		loadCities: 'Cities/all',
		loadTowns: 'Towns/all',
		showLoader: 'showLoader',
		hideLoader: 'hideLoader',
		setBodyClass: 'setBodyClass'
	}), {
		setCurrentBodyClass: function setCurrentBodyClass() {
			if (this.$route.name === 'location') {
				this.setBodyClass('location-page');
			} else {
				this.setBodyClass('index-page');
			}
		},
		loadAllRegions: function loadAllRegions() {
			var _this = this;

			var notification = void 0;

			return this.loadRegions().catch(function (error) {
				_this.buildErrorMessages(error).then(function (data) {
					notification = {
						message: data,
						type: 'danger'
					};

					_this.notify(notification);
				});
			});
		},
		loadAllCities: function loadAllCities(region) {
			var _this2 = this;

			var notification = void 0;
			var query = region ? { region_id: region } : {};

			return this.loadCities(query).then(function (response) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
			}).catch(function (error) {
				_this2.buildErrorMessages(error).then(function (data) {
					notification = {
						message: data,
						type: 'danger'
					};

					_this2.notify(notification);
				});

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
			});
		},
		loadAllTowns: function loadAllTowns(city) {
			var _this3 = this;

			var notification = void 0;
			var query = city ? { city_id: city } : {};

			return this.loadTowns(query).then(function (response) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
			}).catch(function (error) {
				_this3.buildErrorMessages(error).then(function (data) {
					notification = {
						message: data,
						type: 'danger'
					};

					_this3.notify(notification);
				});

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
			});
		},
		notify: function notify(notification) {
			$.notifyClose();

			$.notify({
				icon: "fa fa-bell",
				message: notification.message
			}, {
				type: notification.type,
				timer: 2000,
				placement: {
					from: 'top',
					align: 'center'
				},
				animate: {
					enter: 'animated fadeInDown',
					exit: 'animated fadeOutUp'
				}
			});
		},
		buildErrorMessages: function buildErrorMessages(errors) {
			console.log(errors);

			if (errors.errors) {
				errors = errors.errors;
			} else if (errors.msg) {
				errors = ['Sorry, the form validation failed. Fix all field errors.'];
			} else if (errors.error) {
				errors = [errors.error];
			} else {
				errors = ['Something unexpected happened.'];
			}

			var data = '<b>Error Alert:</b><br>';
			data += '<ul>';

			$.each(errors, function (index, error) {
				data += '<li>' + error + '</li>';
			});

			data += '<ul>';

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
		}
	}),

	mounted: function mounted() {
		this.setCurrentBodyClass();
	}
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);






/* harmony default export */ __webpack_exports__["a"] = ({
	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])({
		user: 'User/getUser',
		settings: 'Settings/get',
		getOrderItems: 'Basket/getOrder',
		isUserLoggedIn: 'User/isLoggedIn',
		getBasketItems: 'Basket/getItems',
		getPaymentModes: 'PaymentModes/getAll',
		getPaymentDetails: 'Basket/getPaymentDetails'
	}), {
		showIndividualCheckOut: function showIndividualCheckOut() {
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.getBasketItems).length > 1 ? true : false;
		},
		individualTotalPrices: function individualTotalPrices() {
			var individualTotals = {};
			var restuarants = this.isCheckOut ? this.getOrderItems : this.getBasketItems;

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(restuarants)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var restaurant = _step.value;

					individualTotals[restaurant[0].menuItem.restaurant.id] = this.getOrderTotalPrice(restaurant);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return individualTotals;
		},
		totalPrice: function totalPrice() {
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.individualTotalPrices).reduce(function (sum, value) {
				return sum + value;
			}, 0);
		},
		totalDeliveryFees: function totalDeliveryFees() {
			var total = 0;
			var restuarants = this.isCheckOut ? this.getOrderItems : this.getBasketItems;

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(restuarants)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var restaurant = _step2.value;

					total += Number(restaurant[0].menuItem.restaurant.delivery_service.delivery_fee);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			return total;
		},
		overallTotalPrice: function overallTotalPrice() {
			return this.totalPrice + this.totalDeliveryFees + this.getServiceFee(this.totalPrice);
		},
		isCheckOut: function isCheckOut() {
			return this.$route.name.toLowerCase() === 'checkout';
		}
	}),

	methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
		loadSettings: 'Settings/all'
	}), {
		getDeliveryFee: function getDeliveryFee() {
			var restaurant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			var deliveryFee = 0;
			var deliveryService = void 0;

			if (restaurant) {
				deliveryService = restaurant[0].menuItem.restaurant.delivery_service;

				if (deliveryService.fee_on_packs) {
					var _iteratorNormalCompletion3 = true;
					var _didIteratorError3 = false;
					var _iteratorError3 = undefined;

					try {
						for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(restaurant), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
							var menuItem = _step3.value;

							deliveryFee += Number(deliveryService.delivery_fee) * Number(menuItem.details.quantity);
						}
					} catch (err) {
						_didIteratorError3 = true;
						_iteratorError3 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion3 && _iterator3.return) {
								_iterator3.return();
							}
						} finally {
							if (_didIteratorError3) {
								throw _iteratorError3;
							}
						}
					}
				} else {
					deliveryFee = Number(deliveryService.delivery_fee);
				}
			}

			return deliveryFee;
		},
		getServiceFee: function getServiceFee() {
			var order_value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

			if (!this.isUserLoggedIn) {
				return 0;
			}

			if (this.getPaymentDetails && this.isCash(this.getPaymentDetails.payment_mode_id)) {
				return Number(order_value) <= Number(this.settings.pivot) ? Number(this.settings.cash_below) : Number(this.settings.cash_above);
			}

			return Number(order_value) * Number(this.settings.online_charge);
		},
		getTotal: function getTotal() {
			for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
				values[_key] = arguments[_key];
			}

			return values.reduce(function (sum, value) {
				return sum + Number(value);
			}, 0);
		},
		getOrderTotalPrice: function getOrderTotalPrice(order) {
			var totalPrice = 0;

			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(order), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var item = _step4.value;

					var itemQuantity = Number(item.details.price);
					var itemPrice = Number(item.details.quantity);

					if (!isNaN(itemQuantity) && !isNaN(itemPrice)) {
						totalPrice += itemQuantity * itemPrice;
					}
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			return totalPrice;
		},
		toggleNavigation: function toggleNavigation(event) {
			$(event.target).parent().find('i').toggleClass('hidden');
		},
		isCash: function isCash(payment_mode_id) {
			var status = false;

			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.getPaymentModes), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var paymentMode = _step5.value;

					if (payment_mode_id === paymentMode.id && paymentMode.name.toLowerCase() === 'cash') {
						status = true;
						break;
					}
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}

			return status;
		}
	}),

	created: function created() {
		var _this = this;

		this.showLoader();

		this.loadSettings().catch(function (error) {
			_this.buildErrorMessages(error).then(function (data) {
				_this.notify({
					message: data,
					type: 'danger'
				});
			});
		}).then(function () {
			return _this.hideLoader();
		});
	}
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Home = function Home(resolve) {
    __webpack_require__.e/* require.ensure */(3).then((function () {
        resolve(__webpack_require__(76));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Restaurants = function Restaurants(resolve) {
    __webpack_require__.e/* require.ensure */(2).then((function () {
        resolve(__webpack_require__(83));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Location = function Location(resolve) {
    __webpack_require__.e/* require.ensure */(8).then((function () {
        resolve(__webpack_require__(77));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var MyAccount = function MyAccount(resolve) {
    __webpack_require__.e/* require.ensure */(5).then((function () {
        resolve(__webpack_require__(71));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ViewRestaurant = function ViewRestaurant(resolve) {
    __webpack_require__.e/* require.ensure */(0).then((function () {
        resolve(__webpack_require__(82));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Basket = function Basket(resolve) {
    __webpack_require__.e/* require.ensure */(4).then((function () {
        resolve(__webpack_require__(73));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Checkout = function Checkout(resolve) {
    __webpack_require__.e/* require.ensure */(1).then((function () {
        resolve(__webpack_require__(75));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var AwaitingPayment = function AwaitingPayment(resolve) {
    __webpack_require__.e/* require.ensure */(9).then((function () {
        resolve(__webpack_require__(74));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var PasswordReset = function PasswordReset(resolve) {
    __webpack_require__.e/* require.ensure */(12).then((function () {
        resolve(__webpack_require__(72));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var MyOrders = function MyOrders(resolve) {
    __webpack_require__.e/* require.ensure */(6).then((function () {
        resolve(__webpack_require__(80));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Privacy = function Privacy(resolve) {
    __webpack_require__.e/* require.ensure */(10).then((function () {
        resolve(__webpack_require__(81));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var NotFound = function NotFound(resolve) {
    __webpack_require__.e/* require.ensure */(11).then((function () {
        resolve(__webpack_require__(78));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var OrderDetails = function OrderDetails(resolve) {
    __webpack_require__.e/* require.ensure */(7).then((function () {
        resolve(__webpack_require__(79));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/',
    component: Home,
    name: 'home'
}, {
    path: '/restaurants',
    component: Restaurants,
    name: 'restaurants'
}, {
    path: '/restaurants/:id',
    component: ViewRestaurant,
    name: 'view_restaurant',
    props: true
}, {
    path: '/location',
    component: Location,
    name: 'location'
}, {
    path: '/my_account',
    component: MyAccount,
    name: 'my_account'
}, {
    path: '/basket',
    component: Basket,
    name: 'basket'
}, {
    path: '/checkout',
    component: Checkout,
    name: 'checkout'
}, {
    path: '/awaiting_payment',
    component: AwaitingPayment,
    name: 'awaiting_payment'
}, {
    path: '/password_reset',
    component: PasswordReset,
    name: 'reset'
}, {
    path: '/orders',
    component: MyOrders,
    name: 'orders'
}, {
    path: '/orders/:order_id',
    component: OrderDetails,
    name: 'view_order',
    props: true
}, {
    path: '/privacy',
    component: Privacy,
    name: 'privacy'
}, {
    path: '*',
    component: NotFound,
    name: 'not_found'
}]);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = ({
	all: function all(data) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('cities', {
			params: data
		}).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	}
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = ({
	all: function all(data) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('menu_items', {
			params: data
		}).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	},
	show: function show(id) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('menu_items/' + id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	}
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = ({
	all: function all(data) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('payment_modes', {
			params: data
		}).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	}
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = ({
	all: function all(data) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('regions', {
			params: data
		}).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	}
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = ({
	all: function all(town_id, params) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('user_restaurants/' + town_id, {
			params: params
		}).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	},
	show: function show(id) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('restaurants/' + id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	}
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = ({
	all: function all(params) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('settings', {
			params: params
		}).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	}
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = ({
	all: function all(data) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('towns', {
			params: data
		}).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	}
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["a"] = ({
	authenticate: function authenticate(user) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].post('users/login', user).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	},
	store: function store(user) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].post('users', user).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	},
	getUserInfo: function getUserInfo(id) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].get('users/' + id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	},
	updateUserInfo: function updateUserInfo(id, user) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].put('users/' + id, user).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	},
	updateUserTown: function updateUserTown(data) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].patch('users/update/town', data).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	},
	getConfirmationToken: function getConfirmationToken(mode) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].post('users/generate_token/' + mode).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	},
	confirmConfirmationToken: function confirmConfirmationToken(mode, token) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].post('users/confirm_token/' + mode, { token: token }).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	},
	requestPasswordReset: function requestPasswordReset(data) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].post('users/request_reset', {
			email: data.email
		}).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	},
	resetPassword: function resetPassword(data) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].post('users/reset_password', data).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	},
	sendMessage: function sendMessage(data) {
		return __WEBPACK_IMPORTED_MODULE_1__index__["a" /* axios */].post('users/contact_us', data).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
		});
	}
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
    setPageTitle: function setPageTitle(_ref, title) {
        var commit = _ref.commit;

        commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["F" /* SET_PAGE_TITLE */], title);
    },
    hideMobileNav: function hideMobileNav(_ref2) {
        var commit = _ref2.commit;

        commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["G" /* HIDE_MOBILE_NAV */]);
    },
    setBodyClass: function setBodyClass(_ref3, newClass) {
        var commit = _ref3.commit;

        commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["H" /* SET_BODY_CLASS */], newClass);
    },
    showLoader: function showLoader(_ref4) {
        var commit = _ref4.commit;

        commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["I" /* SHOW_APP_LOADER */]);
    },
    hideLoader: function hideLoader(_ref5) {
        var commit = _ref5.commit;

        commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["J" /* HIDE_APP_LOADER */]);
    }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	pageTitle: function pageTitle(state) {
		return state.currentPageTitle;
	},
	showLoaderStatus: function showLoaderStatus(state) {
		return state.showLoader;
	}
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_orders__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mutation_types__ = __webpack_require__(3);







var _mutations;





var state = {
	items: JSON.parse(localStorage.getItem('basket_items')) || {},
	order: localStorage.getItem('order') || null,
	count: localStorage.getItem('basket_count') || 0,
	recipient: JSON.parse(localStorage.getItem('recipient')) || {},
	payment_details: JSON.parse(localStorage.getItem('payment_details')) || {},
	backend_order_id: sessionStorage.getItem('backend_order_id') || null
};

var getters = {
	getItems: function getItems(state) {
		return state.items;
	},
	getCount: function getCount(state) {
		return state.count;
	},
	getRecipient: function getRecipient(state) {
		return state.recipient;
	},
	getPaymentDetails: function getPaymentDetails(state) {
		return state.payment_details;
	},
	getOrder: function getOrder(state) {
		var items = {};

		if (state.order) {
			items[state.order] = state.items[state.order];

			return items;
		}

		return state.items;
	},
	getBackendOrderId: function getBackendOrderId(state) {
		return state.backend_order_id;
	}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["g" /* SET_BASKET_ITEM */], function (state, payload) {
	var index = payload.menuItem.restaurant.id;

	if (typeof state.items[index] === 'undefined') {
		__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.items, index, []);
	}

	state.items[index].push({
		key: payload.key,
		details: payload.details,
		menuItem: payload.menuItem
	});

	localStorage.setItem('basket_items', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.items));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["h" /* UPDATE_BASKET_ITEM */], function (state, payload) {
	var restaurant = state.items[payload.menuItem.restaurant.id];
	var item = void 0;

	if (typeof restaurant === 'undefined') {
		return;
	}

	item = restaurant[payload.index];

	if (typeof item === 'undefined') {
		return;
	}

	__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(state.items[payload.menuItem.restaurant.id], payload.index, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, state.items[payload.menuItem.restaurant.id][payload.index], {
		details: payload.details,
		menuItem: payload.menuItem
	}));

	localStorage.setItem('basket_items', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.items));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["i" /* DELETE_BASKET_ITEM */], function (state, payload) {
	var restaurant = state.items[payload.restaurantIndex];
	var item = void 0;

	if (typeof restaurant === 'undefined') {
		return;
	}

	item = restaurant[payload.itemIndex];

	if (typeof item === 'undefined') {
		return;
	}

	if (restaurant.length === 1) {
		__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.items, payload.restaurantIndex);
	} else {
		__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.items[payload.restaurantIndex], payload.itemIndex);
	}

	localStorage.setItem('basket_items', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.items));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["j" /* SET_BASKET_COUNT */], function (state) {
	var totalItems = 0;

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(state.items)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var restaurant = _step.value;
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(restaurant), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var item = _step2.value;

					var quantity = item.details.quantity;

					quantity = isNaN(Number(quantity)) ? 0 : Number(quantity);
					totalItems += quantity;
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	state.count = totalItems;
	localStorage.setItem('basket_count', state.count);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["k" /* CLEAR_BASKET */], function (state) {
	state.items = {};
	state.count = 0;

	localStorage.removeItem('basket_items');
	localStorage.removeItem('basket_count');
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["l" /* SET_ORDER_RECIPIENT */], function (state, payload) {
	state.recipient = payload;
	localStorage.setItem('recipient', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.recipient));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["m" /* SET_ORDER_PAYMENT_DETAILS */], function (state, payload) {
	state.payment_details = payload;
	localStorage.setItem('payment_details', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.payment_details));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["n" /* SET_ORDER */], function (state, payload) {
	state.order = payload;
	localStorage.setItem('order', state.order);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["o" /* CLEAR_ORDER */], function (state) {
	state.order = null;
	localStorage.removeItem('order');
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["p" /* SET_BACKEND_ORDER_ID */], function (state, payload) {
	state.backend_order_id = payload;
	sessionStorage.setItem('backend_order_id', state.backend_order_id);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["q" /* CLEAR_BACKEND_ORDER_ID */], function (state) {
	state.backend_order_id = null;
	sessionStorage.removeItem('backend_order_id');
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["r" /* CLEAR_ORDER_INFORMATION */], function (state) {
	state.backend_order_id = null;
	sessionStorage.removeItem('backend_order_id');

	if (state.order) {
		__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].delete(state.items, state.order);
	} else {
		state.items = {};
	}

	localStorage.setItem('basket_items', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(state.items));

	state.order = null;
	localStorage.removeItem('order');
}), _mutations);

var actions = {
	all: function all(_ref, query) {
		var commit = _ref.commit;

		return MenuItemsService.all(query).then(function (response) {
			commit(SET_MENU_ITEMS, response);

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	add: function add(_ref2, payload) {
		var commit = _ref2.commit;

		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["g" /* SET_BASKET_ITEM */], payload);
		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["j" /* SET_BASKET_COUNT */]);
	},
	update: function update(_ref3, payload) {
		var commit = _ref3.commit;

		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["h" /* UPDATE_BASKET_ITEM */], payload);
		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["j" /* SET_BASKET_COUNT */]);
	},
	delete: function _delete(_ref4, payload) {
		var commit = _ref4.commit;

		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["i" /* DELETE_BASKET_ITEM */], payload);
		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["j" /* SET_BASKET_COUNT */]);
	},
	clear: function clear(_ref5) {
		var commit = _ref5.commit;

		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["k" /* CLEAR_BASKET */]);
		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["j" /* SET_BASKET_COUNT */]);
	},
	setRecipient: function setRecipient(_ref6, payload) {
		var commit = _ref6.commit;

		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["l" /* SET_ORDER_RECIPIENT */], payload);
	},
	setPaymentDetails: function setPaymentDetails(_ref7, payload) {
		var commit = _ref7.commit;

		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["m" /* SET_ORDER_PAYMENT_DETAILS */], payload);
	},
	setOrder: function setOrder(_ref8, payload) {
		var commit = _ref8.commit;

		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["n" /* SET_ORDER */], payload);
	},
	clearOrder: function clearOrder(_ref9) {
		var commit = _ref9.commit;

		commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["o" /* CLEAR_ORDER */]);
	},
	checkPayment: function checkPayment(_ref10, payload) {
		var commit = _ref10.commit;

		return __WEBPACK_IMPORTED_MODULE_7__services_orders__["a" /* default */].check(payload).then(function (response) {
			if (response.errors) {
				commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["q" /* CLEAR_BACKEND_ORDER_ID */]);
			}

			if (response.status && response.status.toLowerCase() === 'success') {
				commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["r" /* CLEAR_ORDER_INFORMATION */]);
				commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["j" /* SET_BASKET_COUNT */]);
			}

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	payNow: function payNow(_ref11, payload) {
		var commit = _ref11.commit;

		return __WEBPACK_IMPORTED_MODULE_7__services_orders__["a" /* default */].store(payload).then(function (response) {
			if (response.payment_status && response.payment_status.toLowerCase() === 'processed') {
				commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["r" /* CLEAR_ORDER_INFORMATION */]);
				commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["j" /* SET_BASKET_COUNT */]);
			} else {
				commit(__WEBPACK_IMPORTED_MODULE_8__mutation_types__["p" /* SET_BACKEND_ORDER_ID */], response.order_id);
			}

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	}
};

var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: namespaced,
	state: state,
	actions: actions,
	getters: getters,
	mutations: mutations
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_cities__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(3);





var state = {
	cities: []
};

var getters = {
	getAll: function getAll(state) {
		return state.cities;
	},
	getPageDetails: function getPageDetails(state) {
		return state.pageDetails;
	}
};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* SET_CITIES */], function (state, payload) {
	state.cities = payload;
});

var actions = {
	all: function all(_ref, query) {
		var commit = _ref.commit;

		return __WEBPACK_IMPORTED_MODULE_2__services_cities__["a" /* default */].all(query).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["s" /* SET_CITIES */], response);
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	add: function add(_ref2, city) {
		var commit = _ref2.commit,
		    actions = _ref2.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_cities__["a" /* default */].add(city).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	show: function show(_ref3, id) {
		var commit = _ref3.commit,
		    actions = _ref3.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_cities__["a" /* default */].show(id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	update: function update(_ref4, city) {
		var commit = _ref4.commit,
		    actions = _ref4.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_cities__["a" /* default */].update(city.id, city).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	delete: function _delete(_ref5, id) {
		var commit = _ref5.commit,
		    actions = _ref5.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_cities__["a" /* default */].delete(id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	}
};

var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: namespaced,
	state: state,
	actions: actions,
	getters: getters,
	mutations: mutations
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__towns__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cities__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basket__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orders__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__regions__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__settings__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__menu_items__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__restaurants__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__payment_modes__ = __webpack_require__(133);











/* harmony default export */ __webpack_exports__["a"] = ({
	User: __WEBPACK_IMPORTED_MODULE_0__user__["a" /* default */],
	Towns: __WEBPACK_IMPORTED_MODULE_1__towns__["a" /* default */],
	Cities: __WEBPACK_IMPORTED_MODULE_2__cities__["a" /* default */],
	Basket: __WEBPACK_IMPORTED_MODULE_3__basket__["a" /* default */],
	Orders: __WEBPACK_IMPORTED_MODULE_4__orders__["a" /* default */],
	Regions: __WEBPACK_IMPORTED_MODULE_5__regions__["a" /* default */],
	Settings: __WEBPACK_IMPORTED_MODULE_6__settings__["a" /* default */],
	MenuItems: __WEBPACK_IMPORTED_MODULE_7__menu_items__["a" /* default */],
	Restaurants: __WEBPACK_IMPORTED_MODULE_8__restaurants__["a" /* default */],
	PaymentModes: __WEBPACK_IMPORTED_MODULE_9__payment_modes__["a" /* default */]
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_menu_items__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(3);





var state = {
	menu_items: [],
	pageDetails: {
		total: 0,
		from: 0,
		to: 0,
		perPage: 0,
		currentPage: 0,
		lastPage: 0
	}
};

var getters = {
	getAll: function getAll(state) {
		return state.menu_items;
	},
	getPageDetails: function getPageDetails(state) {
		return state.pageDetails;
	}
};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_MENU_ITEMS */], function (state, payload) {
	if (payload.data) {
		state.menu_items = payload.data;

		state.pageDetails = {
			total: payload.total,
			from: payload.from,
			to: payload.to,
			currentPage: payload.current_page,
			lastPage: payload.last_page,
			perPage: payload.per_page
		};
	} else {
		state.menu_items = payload;
	}
});

var actions = {
	all: function all(_ref, query) {
		var commit = _ref.commit;

		return __WEBPACK_IMPORTED_MODULE_2__services_menu_items__["a" /* default */].all(query).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_MENU_ITEMS */], response);

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	add: function add(_ref2, menu_item) {
		var commit = _ref2.commit,
		    actions = _ref2.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_menu_items__["a" /* default */].add(menu_item).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	show: function show(_ref3, id) {
		var commit = _ref3.commit,
		    actions = _ref3.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_menu_items__["a" /* default */].show(id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	update: function update(_ref4, menu_item) {
		var commit = _ref4.commit,
		    actions = _ref4.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_menu_items__["a" /* default */].update(menu_item.id, menu_item.data).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	delete: function _delete(_ref5, menu_item_id) {
		var commit = _ref5.commit,
		    actions = _ref5.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_menu_items__["a" /* default */].delete(menu_item_id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	}
};

var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: namespaced,
	state: state,
	actions: actions,
	getters: getters,
	mutations: mutations
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_orders__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(3);





var state = {
	orders: [],
	pageDetails: {
		total: 0,
		from: 0,
		to: 0,
		perPage: 0,
		currentPage: 0,
		lastPage: 0
	}
};

var getters = {
	all: function all(state) {
		return state.orders;
	},
	getPageDetails: function getPageDetails(state) {
		return state.pageDetails;
	}
};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["f" /* SET_ORDERS */], function (state, payload) {
	if (payload.data) {
		state.orders = payload.data;

		state.pageDetails = {
			total: payload.total,
			from: payload.from,
			to: payload.to,
			currentPage: payload.current_page,
			lastPage: payload.last_page,
			perPage: payload.per_page
		};
	} else {
		state.orders = payload;
	}
});

var actions = {
	loadOrders: function loadOrders(_ref, query) {
		var commit = _ref.commit;

		return __WEBPACK_IMPORTED_MODULE_2__services_orders__["a" /* default */].all(query).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["f" /* SET_ORDERS */], response);

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	loadOrder: function loadOrder(_ref2, id) {
		var commit = _ref2.commit;

		return __WEBPACK_IMPORTED_MODULE_2__services_orders__["a" /* default */].show(id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	updateOrder: function updateOrder(_ref3, data) {
		var commit = _ref3.commit;

		return __WEBPACK_IMPORTED_MODULE_2__services_orders__["a" /* default */].update(data.id, data.order).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	}
};

var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: namespaced,
	state: state,
	actions: actions,
	getters: getters,
	mutations: mutations
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_payment_modes__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(3);





var state = {
	paymentModes: []
};

var getters = {
	getAll: function getAll(state) {
		return state.paymentModes;
	}
};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* SET_PAYMENT_MODES */], function (state, payload) {
	state.paymentModes = payload;
});

var actions = {
	all: function all(_ref, query) {
		var commit = _ref.commit;

		return __WEBPACK_IMPORTED_MODULE_2__services_payment_modes__["a" /* default */].all(query).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* SET_PAYMENT_MODES */], response);
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	show: function show(_ref2, id) {
		var commit = _ref2.commit,
		    actions = _ref2.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_payment_modes__["a" /* default */].show(id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	}
};

var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: namespaced,
	state: state,
	actions: actions,
	getters: getters,
	mutations: mutations
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_regions__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(3);





var state = {
	regions: []
};

var getters = {
	getAll: function getAll(state) {
		return state.regions;
	},
	getPageDetails: function getPageDetails(state) {
		return state.pageDetails;
	}
};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* SET_REGIONS */], function (state, payload) {
	state.regions = payload;
});

var actions = {
	all: function all(_ref, query) {
		var commit = _ref.commit;

		return __WEBPACK_IMPORTED_MODULE_2__services_regions__["a" /* default */].all(query).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* SET_REGIONS */], response);
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	add: function add(_ref2, region) {
		var commit = _ref2.commit,
		    actions = _ref2.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_regions__["a" /* default */].add(region).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	show: function show(_ref3, id) {
		var commit = _ref3.commit,
		    actions = _ref3.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_regions__["a" /* default */].show(id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	update: function update(_ref4, region) {
		var commit = _ref4.commit,
		    actions = _ref4.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_regions__["a" /* default */].update(region.id, region).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	delete: function _delete(_ref5, id) {
		var commit = _ref5.commit,
		    actions = _ref5.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_regions__["a" /* default */].delete(id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	}
};

var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: namespaced,
	state: state,
	actions: actions,
	getters: getters,
	mutations: mutations
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_restaurants__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(3);





var state = {
	restaurants: [],
	pageDetails: {
		total: 0,
		from: 0,
		to: 0,
		perPage: 0,
		currentPage: 0,
		lastPage: 0
	}
};

var getters = {
	getAll: function getAll(state) {
		return state.restaurants;
	},
	getPageDetails: function getPageDetails(state) {
		return state.pageDetails;
	}
};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* SET_RESTAURANTS */], function (state, payload) {
	if (payload.data) {
		state.restaurants = payload.data;

		state.pageDetails = {
			total: payload.total,
			from: payload.from,
			to: payload.to,
			currentPage: payload.current_page,
			lastPage: payload.last_page,
			perPage: payload.per_page
		};
	} else {
		state.restaurants = payload;
	}
});

var actions = {
	loadRestaurants: function loadRestaurants(_ref, query) {
		var commit = _ref.commit;

		return __WEBPACK_IMPORTED_MODULE_2__services_restaurants__["a" /* default */].all(query.town_id, query.data).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* SET_RESTAURANTS */], response);
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	loadRestaurant: function loadRestaurant(_ref2, id) {
		var commit = _ref2.commit;

		return __WEBPACK_IMPORTED_MODULE_2__services_restaurants__["a" /* default */].show(id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	}
};

var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: namespaced,
	state: state,
	actions: actions,
	getters: getters,
	mutations: mutations
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_settings__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(3);





var state = {
	settings: {},
	isset: false
};

var getters = {
	get: function get(state) {
		return state.settings;
	},
	isSet: function isSet(state) {
		return state.isset;
	}
};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* SET_SETTINGS */], function (state, payload) {
	state.settings = payload;
	state.isset = true;
});

var actions = {
	all: function all(_ref, query) {
		var commit = _ref.commit,
		    state = _ref.state;

		if (state.isset) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.settings);
		}

		return __WEBPACK_IMPORTED_MODULE_2__services_settings__["a" /* default */].all(query).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* SET_SETTINGS */], response);
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	}
};

var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: namespaced,
	state: state,
	actions: actions,
	getters: getters,
	mutations: mutations
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_towns__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(3);





var state = {
	towns: []
};

var getters = {
	getAll: function getAll(state) {
		return state.towns;
	},
	getPageDetails: function getPageDetails(state) {
		return state.pageDetails;
	}
};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["t" /* SET_TOWNS */], function (state, payload) {
	state.towns = payload;
});

var actions = {
	all: function all(_ref, query) {
		var commit = _ref.commit;

		return __WEBPACK_IMPORTED_MODULE_2__services_towns__["a" /* default */].all(query).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["t" /* SET_TOWNS */], response);
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	add: function add(_ref2, town) {
		var commit = _ref2.commit,
		    actions = _ref2.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_towns__["a" /* default */].add(town).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	show: function show(_ref3, id) {
		var commit = _ref3.commit,
		    actions = _ref3.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_towns__["a" /* default */].show(id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	update: function update(_ref4, town) {
		var commit = _ref4.commit,
		    actions = _ref4.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_towns__["a" /* default */].update(town.id, town).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	delete: function _delete(_ref5, id) {
		var commit = _ref5.commit,
		    actions = _ref5.actions;

		return __WEBPACK_IMPORTED_MODULE_2__services_towns__["a" /* default */].delete(id).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	}
};

var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: namespaced,
	state: state,
	actions: actions,
	getters: getters,
	mutations: mutations
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_user__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(3);





var _mutations;




var state = {
	location: JSON.parse(localStorage.getItem('location')) || {},
	isLoggedIn: localStorage.getItem('user') ? true : false,
	user: JSON.parse(localStorage.getItem('user')) || {},
	showLogin: false,
	showSignup: false,
	showReset: false
};

var getters = {
	isLoggedIn: function isLoggedIn(state) {
		return state.isLoggedIn;
	},
	getUser: function getUser(state) {
		return state.user;
	},
	isLocationSet: function isLocationSet(state) {
		return typeof state.location !== 'undefined' && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.location).length > 0 ? true : false;
	},
	getLocation: function getLocation(state) {
		return state.location;
	},
	shouldShowLogin: function shouldShowLogin(state) {
		return state.showLogin;
	},
	shouldShowSignup: function shouldShowSignup(state) {
		return state.showSignup;
	},
	shouldShowReset: function shouldShowReset(state) {
		return state.showReset;
	}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["u" /* AUTHENTICATE */], function (state) {
	state.isLoggedIn = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["v" /* AUTHENTICATION_FAILED */], function (state) {
	state.isLoggedIn = false;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* UPDATE_USER_INFO */], function (state, user) {
	if (user) {
		state.user = user;
		localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(user));
	} else {
		state.user = {};
		localStorage.removeItem('user');
	}
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["x" /* SET_USER_LOCATION */], function (state, location) {
	state.location = location;
	localStorage.setItem('location', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(location));
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["y" /* LOGOUT */], function (state) {
	state.user = {};
	state.isLoggedIn = false;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["z" /* SHOW_LOGIN_MODAL */], function (state) {
	state.showLogin = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["A" /* HIDE_LOGIN_MODAL */], function (state) {
	state.showLogin = false;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["B" /* SHOW_SIGNUP_MODAL */], function (state) {
	state.showSignup = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["C" /* HIDE_SIGNUP_MODAL */], function (state) {
	state.showSignup = false;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["D" /* SHOW_RESET_MODAL */], function (state) {
	state.showReset = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["E" /* HIDE_RESET_MODAL */], function (state) {
	state.showReset = false;
}), _mutations);

var actions = {
	authenticate: function authenticate(_ref, user) {
		var commit = _ref.commit;

		return __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].authenticate(user).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["u" /* AUTHENTICATE */]);
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* UPDATE_USER_INFO */], response);

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}, function (error) {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["v" /* AUTHENTICATION_FAILED */]);
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* UPDATE_USER_INFO */]);

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	signup: function signup(_ref2, user) {
		var commit = _ref2.commit;

		return __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].store(user).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["u" /* AUTHENTICATE */]);
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* UPDATE_USER_INFO */], response);

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}, function (error) {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["v" /* AUTHENTICATION_FAILED */]);
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* UPDATE_USER_INFO */]);

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	logout: function logout(_ref3) {
		var commit = _ref3.commit;

		commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["y" /* LOGOUT */]);
		commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* UPDATE_USER_INFO */]);
	},
	getUserInfo: function getUserInfo(_ref4) {
		var commit = _ref4.commit,
		    getters = _ref4.getters;

		var user_id = getters.getUser.id;
		return __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].getUserInfo(user_id).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* UPDATE_USER_INFO */], response);

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	updateUserInfo: function updateUserInfo(_ref5, user) {
		var commit = _ref5.commit,
		    getters = _ref5.getters;

		var user_id = getters.getUser.id;

		return __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].updateUserInfo(user_id, user).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* UPDATE_USER_INFO */], response);

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	updateLocation: function updateLocation(_ref6, payload) {
		var commit = _ref6.commit;

		if (payload.save === true) {
			var data = {
				town_id: payload.location.town_id
			};

			return __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].updateUserTown(data).then(function (response) {
				commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["x" /* SET_USER_LOCATION */], payload.location);

				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
			}).catch(function (error) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
			});
		} else {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["x" /* SET_USER_LOCATION */], payload.location);
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(payload.location);
		}
	},
	setShowLogin: function setShowLogin(_ref7, isShow) {
		var commit = _ref7.commit;

		if (isShow === true) {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["z" /* SHOW_LOGIN_MODAL */]);
		} else {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["A" /* HIDE_LOGIN_MODAL */]);
		}
	},
	setShowSignup: function setShowSignup(_ref8, isShow) {
		var commit = _ref8.commit;

		if (isShow === true) {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["B" /* SHOW_SIGNUP_MODAL */]);
		} else {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["C" /* HIDE_SIGNUP_MODAL */]);
		}
	},
	setShowReset: function setShowReset(_ref9, isShow) {
		var commit = _ref9.commit;

		if (isShow === true) {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["D" /* SHOW_RESET_MODAL */]);
		} else {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["E" /* HIDE_RESET_MODAL */]);
		}
	},
	getConfirmationToken: function getConfirmationToken(_ref10, mode) {
		var commit = _ref10.commit;

		return __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].getConfirmationToken(mode);
	},
	confirmConfirmationToken: function confirmConfirmationToken(_ref11, data) {
		var commit = _ref11.commit;

		return __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].confirmConfirmationToken(data.rel, data.token).then(function (response) {
			commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["w" /* UPDATE_USER_INFO */], response);

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	requestPasswordReset: function requestPasswordReset(_ref12, data) {
		var commit = _ref12.commit;

		return __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].requestPasswordReset(data).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	resetPassword: function resetPassword(_ref13, data) {
		var commit = _ref13.commit;

		return __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].resetPassword(data).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	},
	sendMessage: function sendMessage(_ref14, data) {
		var commit = _ref14.commit;

		return __WEBPACK_IMPORTED_MODULE_4__services_user__["a" /* default */].sendMessage(data).then(function (response) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
		}).catch(function (error) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
		});
	}
};

var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: namespaced,
	state: state,
	actions: actions,
	getters: getters,
	mutations: mutations
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(3);


var _SET_PAGE_TITLE$HIDE_;



/* harmony default export */ __webpack_exports__["a"] = (_SET_PAGE_TITLE$HIDE_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PAGE_TITLE$HIDE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["F" /* SET_PAGE_TITLE */], function (state, title) {
	document.title = title + ' - Ezi Food';
	state.currentPageTitle = title;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PAGE_TITLE$HIDE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["G" /* HIDE_MOBILE_NAV */], function (state) {
	var html = document.querySelector('html');

	if (html) {
		html.classList.remove('nav-open');
		gaia.misc.navbar_menu_visible = 0;
	}
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PAGE_TITLE$HIDE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["H" /* SET_BODY_CLASS */], function (state, newClass) {
	state.bodyClass = newClass;
	document.querySelector('body').className = state.bodyClass;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PAGE_TITLE$HIDE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["I" /* SHOW_APP_LOADER */], function (state) {
	state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_PAGE_TITLE$HIDE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["J" /* HIDE_APP_LOADER */], function (state) {
	state.showLoader = false;
}), _SET_PAGE_TITLE$HIDE_);

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(211),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6081f2dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(215),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(213),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-747bb8bf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(210),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56b42a1e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(186)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(208),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-144f623a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(207),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-035bd9d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(212),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65405149",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(216),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ffd8532e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var Component = __webpack_require__(4)(
  /* script */
  null,
  /* template */
  __webpack_require__(209),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1be702e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(206),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02bc3017",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showPagination) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 text-center"
  }, [_c('ul', {
    staticClass: "pager"
  }, [_c('li', {
    class: {
      disabled: _vm.pageDetails.currentPage == 1
    }
  }, [_c('a', {
    staticClass: "btn btn-info btn-fill",
    attrs: {
      "disabled": _vm.pageDetails.currentPage == 1
    },
    on: {
      "click": function($event) {
        _vm.navigate(_vm.prevPage, $event)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")]), _vm._v("\n\t\t\t\t\t\tPrev\n\t\t\t\t")])]), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.pageDetails.currentPage == _vm.pageDetails.lastPage
    }
  }, [_c('a', {
    staticClass: "btn btn-info btn-fill",
    attrs: {
      "disabled": _vm.pageDetails.currentPage == _vm.pageDetails.lastPage
    },
    on: {
      "click": function($event) {
        _vm.navigate(_vm.nextPage, $event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tNext\n\t\t\t\t\t\t"), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal custom-modal fade",
    attrs: {
      "id": _vm.rel + '-delete-modal',
      "role": "dialog",
      "aria-labelledby": "delete-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._t("title")], 2)]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "delete-modal-form",
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.deleteResource($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 margin-top-bottom"
  }, [_vm._t("message")], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-fill",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-fill",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("No")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top",
    attrs: {
      "color-on-scroll": "100"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(26)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right navbar-uppercase"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'restaurants'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Restaurants")])]), _vm._v(" "), (_vm.isUserLoggedIn) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'orders'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("My Orders")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'location'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Change Location")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Privacy")])]), _vm._v(" "), (!_vm.isUserLoggedIn) ? [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loginUser($event)
      }
    }
  }, [_vm._v("Log In")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signupUser($event)
      }
    }
  }, [_vm._v("Sign Up")])])] : [_c('router-link', {
    attrs: {
      "to": {
        name: 'my_account'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("My Account")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logoutUser($event)
      }
    }
  }, [_vm._v("Log Out")])])], _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'basket'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "text-info",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-basket"
  }), _vm._v(" "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.basketCount))])])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "id": "menu-toggle",
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#example"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar1"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar2"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar3"
  })])
}]}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('img', {
    staticClass: "blink-image",
    attrs: {
      "width": "80px",
      "src": __webpack_require__(70)
    }
  })])
}]}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer footer-small footer-color-black",
    attrs: {
      "data-color": "black"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendUserMessage($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactUs.email),
      expression: "contactUs.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.email),
      expression: "rules.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "placeholder": "user@ezifood.com"
    },
    domProps: {
      "value": (_vm.contactUs.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactUs.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('email')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('phone')
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactUs.phone),
      expression: "contactUs.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.phone),
      expression: "rules.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phone",
      "name": "phone",
      "placeholder": "0241000111"
    },
    domProps: {
      "value": (_vm.contactUs.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactUs.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('phone')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('message')
    }
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactUs.message),
      expression: "contactUs.message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.message),
      expression: "rules.message"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "message",
      "name": "message",
      "placeholder": "Ezifood is the best"
    },
    domProps: {
      "value": (_vm.contactUs.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactUs.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('message')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('message')))])], 1), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n            © " + _vm._s(_vm.currentYear) + " - Ezifood - A product of Ezitek Solutions\n        ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("About")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("Ezifood is a product of Ezitek Solutions. It is a web and mobile application that allows you to order food from your favourite restaurants in simple and easy steps.")]), _vm._v(" "), _c('h2', {
    staticClass: "text-center large-margin-top"
  }, [_vm._v("Get In Touch")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "info-mail-link",
      "href": "mailto:info@ezifood.com"
    }
  }, [_vm._v("info@ezifood.com")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone:")]), _vm._v(" 054 204 3151")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Location:")]), _vm._v(" KNUST - Kumasi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center margin-top-bottom"
  }, [_c('button', {
    staticClass: "btn btn-default btn-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Contact Us")])])
}]}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade custom-modal auth-modal",
    attrs: {
      "id": "login-modal",
      "role": "dialog",
      "aria-labelledby": "login-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loginUser($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.email),
      expression: "rules.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "placeholder": "user@ezifood.com",
      "autocomplete": "false"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('email')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.password),
      expression: "rules.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "password",
      "placeholder": "******",
      "autocomplete": "false"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('password')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-fill small-margin-top btn-block",
    attrs: {
      "type": "submit",
      "disabled": !_vm.allowLogin
    }
  }, [_vm._v("Log In")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-info btn-fill small-margin-top btn-block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.initReset($event)
      }
    }
  }, [_vm._v("Forgot Your Password ?")])])]), _vm._v(" "), _c('p', {
    staticClass: "text-center small-margin-top"
  }, [_vm._v("Don't have an account? "), _c('a', {
    staticClass: "text-warning pointer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.initSignup($event)
      }
    }
  }, [_vm._v("Sign Up")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "auth-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(26)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center small-margin-top"
  }, [_vm._v("Hurry! Your food awaits!")])])
}]}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade custom-modal auth-modal",
    attrs: {
      "id": "signup-modal",
      "role": "dialog",
      "aria-labelledby": "signup-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signupUser($event)
      }
    }
  }, [(!_vm.showNextStep) ? [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.name),
      expression: "rules.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "name": "name",
      "placeholder": "Ezi Guy"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('name')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.email),
      expression: "rules.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "placeholder": "user@ezifood.com"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('email')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('phone')
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.phone),
      expression: "rules.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phone",
      "name": "phone",
      "placeholder": "0542010203"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('phone')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-fill small-margin-top",
    attrs: {
      "type": "button",
      "disabled": !_vm.allowNext
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToNextStep($event)
      }
    }
  }, [_vm._v("Next")])])] : [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.password),
      expression: "rules.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "password",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('password')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password_confirmation')
    }
  }, [_c('label', {
    attrs: {
      "for": "password_confirmation"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password_confirmation),
      expression: "user.password_confirmation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.password_confirmation),
      expression: "rules.password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password_confirmation",
      "name": "password_confirmation",
      "data-vv-as": "password",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.user.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password_confirmation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('password_confirmation')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('password_confirmation')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-fill small-margin-top",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToPreviousStep($event)
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-fill small-margin-top",
    attrs: {
      "type": "submit",
      "disabled": !_vm.allowSignup
    }
  }, [_vm._v("Sign Up")])])], _vm._v(" "), _c('p', {
    staticClass: "text-center small-margin-top"
  }, [_vm._v("Already have an account? "), _c('a', {
    staticClass: "text-warning pointer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.initLogin($event)
      }
    }
  }, [_vm._v("Login")])])], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "auth-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(26)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center small-margin-top"
  }, [_vm._v("Hurry! Your food awaits!")])])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isUserLocationSet) ? _c('app-header', {
    on: {
      "logout": _vm.logoutUser
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.isUserLocationSet) ? _c('app-footer') : _vm._e()], 1), _vm._v(" "), _c('app-login', {
    attrs: {
      "isOpenModal": _vm.showLoginModal
    }
  }), _vm._v(" "), _c('app-signup', {
    attrs: {
      "isOpenModal": _vm.showSignupModal
    }
  }), _vm._v(" "), _c('app-reset', {
    attrs: {
      "isOpenModal": _vm.showResetModal
    }
  }), _vm._v(" "), _c('app-loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader),
      expression: "showLoader"
    }]
  }), _vm._v(" "), _c('mobile-basket', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMobileBasket),
      expression: "showMobileBasket"
    }]
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade custom-modal auth-modal",
    attrs: {
      "id": "reset-modal",
      "role": "dialog",
      "aria-labelledby": "reset-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendRequest($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules.email),
      expression: "rules.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "placeholder": "user@ezifood.com"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('error-label', {
    attrs: {
      "show": _vm.errors.has('email')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-fill small-margin-top btn-block",
    attrs: {
      "type": "submit",
      "disabled": !_vm.email
    }
  }, [_vm._v("Send Request")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "auth-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(26)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center small-margin-top"
  }, [_vm._v("Request Password Reset")])])
}]}

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "floating-basket"
    },
    on: {
      "click": _vm.goToBasket
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-basket"
  }), _vm._v(" "), _c('span', {
    staticClass: "bottom-badge"
  }, [_vm._v(_vm._s(_vm.basketCount))])])
},staticRenderFns: []}

/***/ })
],[114]);


// WEBPACK FOOTER //
// static/js/app.101cbad8c9c21a629423.js